<div>
  <app-endpoints-table></app-endpoints-table>
</div>


@if (endpointInfoOpen == true) {
  <app-endpoint-info [chart]="chart"
  (openEndpointDetails)="endpointAllDetail()"></app-endpoint-info>
}
<div class="overlay" (click)="hideView()"
[ngStyle]="{'display' : (endpointAllDetails || endpointInfoOpen) ? 'block' : 'none'}"></div>